import PropTypes from 'prop-types';

// material
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions
} from '@mui/material';

export default function ConfirmAlertDialog({
  openConfirmAlertDialog,
  message,
  title,
  positiveBtnLable,
  negativeBtnLable,
  handleClose,
  handlePositiveClose,
  handleNegativeClose
}) {

  return (
    <Dialog
      open={openConfirmAlertDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="confirm-alert-dialog-desc"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-alert-dialog-desc">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleNegativeClose}>
          {negativeBtnLable}
        </Button>
        <Button variant="contained" onClick={handlePositiveClose}>
          {positiveBtnLable}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmAlertDialog.propTypes = {
  openConfirmAlertDialog: PropTypes.bool,
  message: PropTypes.string,
  title: PropTypes.string,
  positiveBtnLable: PropTypes.string,
  negativeBtnLable: PropTypes.string,
  handleClose: PropTypes.func,
  handlePositiveClose: PropTypes.func,
  handleNegativeClose: PropTypes.func
};
